import { inject, Injectable } from '@angular/core';
import { rmaShareReplay } from '@rma/generic/rxjs/operators';
import { PublicProfileContextService, PublicUserContextService } from '@rma/public/accounts/user';
import { combineLatest, Observable, of, switchMap } from 'rxjs';
import { SubscriptionApiService } from '../data-access/subscription-api.service';
import { SubscriptionPlanAccess } from './subscription-plan-access.model';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionFeatureService {
  private readonly subscriptionApiService = inject(SubscriptionApiService);
  private readonly userService = inject(PublicUserContextService);
  private readonly profile = inject(PublicProfileContextService);

  public get currentAccess$(): Observable<SubscriptionPlanAccess | undefined> {
    return this.userService.currentUser$.pipe(
      switchMap((user) => {
        // Consumers have no plan access; the Agent/Agency split and the agency code are profile facts.
        if (!user || user.userType === 'Consumer') {
          return of(undefined);
        }

        return combineLatest([this.profile.isIndividual$, this.profile.profileCode$]).pipe(
          switchMap(([isIndividual, profileCode]) =>
            isIndividual ? this.subscriptionApiService.getCurrentAgentAccess() : this.subscriptionApiService.getAgencyAccess(profileCode),
          ),
        );
      }),
      rmaShareReplay(),
    );
  }
}
